export default {
  resource: "admin",
  path: "/admin",

  map() {
    this.route("manage-account", {
      resetNamespace: true,
    });
    this.route("manage-updates", {
      resetNamespace: true,
    });
    this.route("support", {
      resetNamespace: true,
    });
  },
};
